import { render, staticRenderFns } from "./Welcomes.vue?vue&type=template&id=46d0439c&scoped=true&"
import script from "./Welcomes.vue?vue&type=script&lang=js&"
export * from "./Welcomes.vue?vue&type=script&lang=js&"
import style0 from "./Welcomes.vue?vue&type=style&index=0&id=46d0439c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d0439c",
  null
  
)

export default component.exports